export default "https://server.zhongzhiapp.com/api/"
 
 



// WEBPACK FOOTER //
// ./src/util/baseUrl.js